export const getTrend = (array) => {
    if (array.length < 2) return 'neutral';

    const last = array[array.length - 1];
    const previous = array[array.length - 2];

    if (last > previous) return 'up';
    if (last < previous) return 'down';

  return 'neutral';
};

export const formatDataToUrlQueryParams = (data) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
        if (value) {
            params.append(key, value);
        }
    });
    return params.toString();
};